import SearchInput from './SearchInput.view';
export default SearchInput;
